import React from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import { Stack, DialogContent, IconButton, DialogActions, Box } from '@mui/material'
import { Dialog, Typography, makeStyles } from '@material-ui/core'

const CustomPopup = ({ open, title, onClose, children, actions, maxWidth }) => {
  const classes = useStyles()
  return (
    <Dialog
      disableEnforceFocus={false}
      fullWidth
      maxWidth={maxWidth}
      open={open}
      className={classes.modal}>
      <Stack direction="row" sx={styles.dialogHeading}>
        <Typography variant="h4">{title}</Typography>
        <IconButton sx={styles.iconButton} onClick={onClose}>
          <ClearIcon fontSize="small" />
        </IconButton>
      </Stack>
      <DialogContent sx={styles.dialogContent}>{children}</DialogContent>
      {actions && (
        <DialogActions>
          <Box mr={0.4}>{actions}</Box>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default CustomPopup

const useStyles = makeStyles({
  modal: {
    '.MuiDialog-paper': {
      borderRadius: '18px'
    }
  }
})

const styles = {
  modal: {
    '.MuiDialog-paper': {
      borderRadius: '18px'
    }
  },
  dialogHeading: {
    justifyContent: 'space-between',
    alignItems: 'center',
    p: '16px 24px'
  },
  title: {
    flex: 1,
    textAlign: 'center'
  },
  iconButton: {
    padding: '4px'
  },
  dialogContent: {
    pt: '8px'
  }
}
